export default [
  {
    path: "/workout/hub",
    name: "Workouts_v2",
    component: () => import(/* webpackChunkName: "workouts" */ "@/views/workouts/v2/trainingsHub.vue"),
    meta: {
      hideBottomNavigation: true,
      navbarTitle: "Trainingshub",
      hideAvatar: true,
      hideLogo: true,
      addAppBarPadding: true,
      fullWidth: true,
    },
  },
  {
    path: "/workout/summary",
    name: "WorkoutSummary",
    meta: {
      hideBottomNavigation: true,
      fullWidth: true,
    },
    component: () => import("@/views/workouts/v2/runWorkout/runWorkoutSummary.vue"),
  },
  {
    path: "/workout/run/split",
    name: "Workout_run",
    component: () => import(/* webpackChunkName: "workouts" */ "@/views/workouts/v2/runWorkout/runWorkout.vue"),
    meta: {
      navbarTitle: "Training",
      hideBottomNavigation: true,
      fullWidth: true,
    },
  },
]
